import { visibleIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Show = createIcon({
  displayName: 'Show',
  paths: [
    'M171.691 512c54.229 65.664 192.725 213.333 340.309 213.333 147.712 0 286.293-147.925 340.309-213.333-54.229-65.664-192.725-213.333-340.309-213.333-147.712 0-286.293 147.925-340.309 213.333zM512 213.333c181.077 0 337.024 160.299 407.509 246.016 25.557 31.104 25.557 74.197 0 105.301-70.485 85.717-226.432 246.016-407.509 246.016s-337.024-160.299-407.509-246.016c-25.557-31.104-25.557-74.197 0-105.301 70.485-85.717 226.432-246.016 407.509-246.016zM512 405.333c0 35.328 28.629 64 64 64 18.517 0 35.029-7.979 46.72-20.48 10.667 18.688 17.28 40.064 17.28 63.147 0 70.699-57.301 128-128 128s-128-57.301-128-128c0-70.699 57.301-128 128-128 0.683 0 1.353 0.097 2.022 0.194 0.589 0.085 1.178 0.17 1.775 0.19-2.304 6.613-3.797 13.568-3.797 20.949z'
  ],
  canvasPaths: canvasIconPaths(visibleIcon)
})
